module.exports = __webpack_public_path__ + "media/images/clipboard-422bfb644f74c525b4cf92d8a875fa0b.svg";